/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M7 16.5L6.69611 16.9179C5.50352 18.5577 4.90722 19.3776 4.92851 20.0622C4.94703 20.6581 5.23046 21.2146 5.7015 21.5801C6.24263 22 7.25644 22 9.28406 22H14.7159C16.7436 22 17.7574 22 18.2985 21.5801C18.7695 21.2146 19.053 20.6581 19.0715 20.0622C19.0928 19.3776 18.4965 18.5577 17.3039 16.9179L17 16.5M14 10C14 11.1046 13.1046 12 12 12C10.8954 12 10 11.1046 10 10C10 8.89543 10.8954 8 12 8C13.1046 8 14 8.89543 14 10Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<circle
				cx="12"
				cy="10"
				r="8"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 17.9998C16.4183 17.9998 20 14.418 20 9.99976C20 5.58148 16.4183 1.99976 12 1.99976C7.58172 1.99976 4 5.58148 4 9.99976C4 14.418 7.58172 17.9998 12 17.9998ZM12 11.9998C13.1046 11.9998 14 11.1043 14 9.99976C14 8.89519 13.1046 7.99976 12 7.99976C10.8954 7.99976 10 8.89519 10 9.99976C10 11.1043 10.8954 11.9998 12 11.9998Z"
				fill="currentColor"
			/>
			<path
				d="M7 16.5L6.69611 16.9179C5.50352 18.5577 4.90722 19.3776 4.92851 20.0622C4.94703 20.6581 5.23046 21.2146 5.7015 21.5801C6.24263 22 7.25644 22 9.28406 22H14.7159C16.7436 22 17.7574 22 18.2985 21.5801C18.7695 21.2146 19.053 20.6581 19.0715 20.0622C19.0928 19.3776 18.4965 18.5577 17.3039 16.9179L17 16.5M20 10C20 14.4183 16.4183 18 12 18C7.58172 18 4 14.4183 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10ZM14 10C14 11.1046 13.1046 12 12 12C10.8954 12 10 11.1046 10 10C10 8.89543 10.8954 8 12 8C13.1046 8 14 8.89543 14 10Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.0002 1.25024C7.16769 1.25024 3.25018 5.16775 3.25018 10.0002C3.25018 14.8327 7.16769 18.7502 12.0002 18.7502C16.8327 18.7502 20.7502 14.8327 20.7502 10.0002C20.7502 5.16775 16.8327 1.25024 12.0002 1.25024ZM12.0002 12.0002C13.1047 12.0002 14.0002 11.1048 14.0002 10.0002C14.0002 8.89567 13.1048 8.00024 12.0002 8.00024C10.8956 8.00024 10.0002 8.89567 10.0002 10.0002C10.0002 11.1048 10.8956 12.0002 12.0002 12.0002Z"
				fill="currentColor"
			/>
			<path
				d="M5.80875 18.1697C5.62906 18.0333 5.53922 17.9651 5.4634 17.939C5.30241 17.8837 5.14681 17.9066 5.00864 18.0061C4.94357 18.0529 4.88261 18.1367 4.7607 18.3044C3.96998 19.3916 3.57463 19.9352 3.49058 20.374C3.31871 21.2715 3.77691 22.1713 4.60379 22.5601C5.0081 22.7502 5.68028 22.7502 7.02463 22.7502H16.9757C18.3201 22.7502 18.9922 22.7502 19.3965 22.5601C20.2234 22.1713 20.6816 21.2715 20.5098 20.374C20.4257 19.9352 20.0304 19.3916 19.2397 18.3044C19.1177 18.1368 19.0568 18.0529 18.9917 18.0061C18.8535 17.9066 18.6979 17.8837 18.5369 17.9391C18.4611 17.9651 18.3713 18.0333 18.1916 18.1697C16.4715 19.4754 14.3263 20.2502 12.0002 20.2502C9.67405 20.2502 7.5289 19.4754 5.80875 18.1697Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M7.14279 16.3572C8.48951 17.3877 10.1733 18 12 18C12.6906 18 13.3608 17.9125 14 17.748M7.14279 16.3572C5.23225 14.8953 4 12.5915 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10C20 11.9347 19.3132 13.709 18.1701 15.0924C17.6847 15.68 17.4419 15.9738 17.3836 16.1652C17.3169 16.3846 17.3144 16.4625 17.3669 16.6857C17.4128 16.8805 17.6219 17.1694 18.04 17.7471C18.6538 18.5954 19.1766 19.59 19.0416 20.3497C18.9723 20.7401 18.7885 21.1011 18.5135 21.3869C17.9234 22 16.682 22 14.1993 22H9.80074C7.31796 22 6.07658 22 5.48649 21.3869C5.21152 21.1011 5.02769 20.7401 4.95835 20.3497C4.73334 19.0827 6.33746 17.1625 7.14279 16.3572ZM14 10C14 11.1046 13.1046 12 12 12C10.8954 12 10 11.1046 10 10C10 8.89543 10.8954 8 12 8"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M7 16.5L6.69611 16.9179C5.50352 18.5577 4.90722 19.3776 4.92851 20.0622C4.94703 20.6581 5.23046 21.2146 5.7015 21.5801C6.24263 22 7.25644 22 9.28406 22H14.7159C16.7436 22 17.7574 22 18.2985 21.5801C18.7695 21.2146 19.053 20.6581 19.0715 20.0622C19.0928 19.3776 18.4965 18.5577 17.3039 16.9179L17 16.5M20 10C20 14.4183 16.4183 18 12 18C7.58172 18 4 14.4183 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10ZM14 10C14 11.1046 13.1046 12 12 12C10.8954 12 10 11.1046 10 10C10 8.89543 10.8954 8 12 8C13.1046 8 14 8.89543 14 10Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 1.25C7.16751 1.25 3.25 5.16751 3.25 10C3.25 14.8325 7.16751 18.75 12 18.75C16.8325 18.75 20.75 14.8325 20.75 10C20.75 5.16751 16.8325 1.25 12 1.25Z"
				fill="currentColor"
			/>
			<path
				d="M5.80875 18.1695C5.62906 18.0331 5.53922 17.9649 5.4634 17.9388C5.30241 17.8834 5.14681 17.9064 5.00864 18.0058C4.94357 18.0527 4.88261 18.1365 4.7607 18.3041C3.96998 19.3914 3.57463 19.935 3.49058 20.3738C3.31871 21.2712 3.77691 22.171 4.60379 22.5599C5.0081 22.75 5.68028 22.75 7.02463 22.75H16.9757C18.3201 22.75 18.9922 22.75 19.3965 22.5599C20.2234 22.171 20.6816 21.2712 20.5098 20.3738C20.4257 19.935 20.0304 19.3914 19.2397 18.3041C19.1177 18.1365 19.0568 18.0527 18.9917 18.0058C18.8535 17.9064 18.6979 17.8834 18.5369 17.9388C18.4611 17.9649 18.3713 18.0331 18.1916 18.1695C16.4715 19.4751 14.3263 20.25 12.0002 20.25C9.67405 20.25 7.5289 19.4751 5.80875 18.1695Z"
				fill="currentColor"
			/>
			<path
				d="M12 11.9999C13.1046 11.9999 14 11.1044 14 9.99988C14 8.89531 13.1046 7.99988 12 7.99988C10.8954 7.99988 10 8.89531 10 9.99988C10 11.1044 10.8954 11.9999 12 11.9999Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
